/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:07:36
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 13:40:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/TopConfigs/index.tsx
 */
import { getContentButtonThemes } from '@/src/request/salesChannel/content';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';
import useRequest from '@ahooksjs/use-request';
import React from 'react';
import ButtonText from './ButtonText';
import ContentSetting from './ContentSetting';
const Top = (props) => {
  const { isPrimary, currentSize, currentStyle, contentUuid } = props;
  const { data } = useRequest(() => getContentButtonThemes(contentUuid));
  const responsiveMobile =
    currentStyle === WebSiteSubType.ResponsivePage &&
    (currentSize === EPreviewSize.TABLET ||
      currentSize === EPreviewSize.MOBILE);
  return (
    <React.Fragment>
      <ContentSetting
        isPrimary={isPrimary}
        currentSize={currentSize}
        currentStyle={currentStyle}
      />
      {!(!isPrimary && responsiveMobile) && (
        <ButtonText
          themes={data}
          isPrimary={isPrimary}
          currentSize={currentSize}
          currentStyle={currentStyle}
        />
      )}
    </React.Fragment>
  );
};
export default Top;
